export enum TokenType {
  IdToken = 'id_token',
  AccessToken = 'access_token',
}
